import React from 'react'

export const FEATURE_FLAGS = {
  // Core Features (Always enabled)
  AUTHENTICATION: true,
  DASHBOARD_LAYOUT: true,
  COURSE_MATERIALS: true,
  
  // Navigation Features
  OVERVIEW: true,
  MY_TUTOR: true,
  MESSAGES: true,
  ACCOUNT_SETTINGS: true,
  SEARCH_RESULTS: true,
  SUPPORT: true,
  
  // Content Features
  CLASS_VIDEO: true,           // For tutoring sessions
  SCHOOL_PROFILE: true,
  TUTOR_PROFILE: true,
  
  // Dashboard Features
  INSTRUCTOR_DASHBOARD: true,
  SCHOOL_DASHBOARD: true,
  ADMIN: true,
  ADMIN_USERS: true,
  ADMIN_PLATFORM: true,
  ADMIN_AI_SETTINGS: true,
  ADMIN_FINANCIAL: true,
  ADMIN_SUPPORT: true,
  ADMIN_CONTENT: true,
  ADMIN_ANALYTICS: false,
  ADMIN_LOGS: true,
  ADMIN_SESSIONS: true,
  
  // Disabled Features (Production v1.0.0)
  MY_WEBINARS: false,          // Removed for production
  MY_COURSES: false,           // Removed for production
  MY_PAYMENTS: true,           // Enabled for current version
  
  // Future Features (v2.0.0+)
  AI_TUTOR: false,
  PAYMENT_SYSTEM: false,
  ANALYTICS: false,
}

// Feature Guard Component
interface FeatureGuardProps {
  feature: keyof typeof FEATURE_FLAGS
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const FeatureGuard = ({ feature, children, fallback = null }: FeatureGuardProps) => {
  return FEATURE_FLAGS[feature] ? children : fallback
}

// Helper function to check if feature is enabled
export const isFeatureEnabled = (feature: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[feature]
}
